import {clsx} from "clsx";
import React from "react";
import {text} from "../../../constants/text";

const DeliveryMethodSelector = ({activeTab, onTabChange}) => (
    <div>
        <div className="font-medium mb-3">{text.selectOrderHandoverMethod}</div>
        <div className="flex space-x-6 pb-2">
            <label className="flex items-center">
                <div className="relative flex items-center">
                    <input
                        type="radio"
                        name="deliveryType"
                        checked={activeTab === 'pickup'}
                        onChange={() => onTabChange('pickup')}
                        className="w-4 h-4 opacity-0 absolute cursor-pointer" // Hide original radio
                    />
                    <div
                        className={`w-4 h-4 rounded-full border flex items-center justify-center ${activeTab === 'pickup' ? 'border-green-600' : 'border-gray-400'}`}>
                        {activeTab === 'pickup' && <div className="w-2 h-2 rounded-full bg-green-600"></div>}
                    </div>
                </div>
                <span className={clsx(activeTab === 'pickup' ? 'font-bold' : '', 'ml-2')}>{text.pickupAtLocation}</span>
            </label>
            <label className="flex items-center">
                <div className="relative flex items-center">
                    <input
                        type="radio"
                        name="deliveryType"
                        checked={activeTab === 'postOffice'}
                        onChange={() => onTabChange('postOffice')}
                        className="w-4 h-4 opacity-0 absolute cursor-pointer" // Hide original radio
                    />
                    <div
                        className={`w-4 h-4 rounded-full border flex items-center justify-center ${activeTab === 'postOffice' ? 'border-green-600' : 'border-gray-400'}`}>
                        {activeTab === 'postOffice' && <div className="w-2 h-2 rounded-full bg-green-600"></div>}
                    </div>
                </div>
                <span
                    className={clsx(activeTab === 'postOffice' ? 'font-bold' : '', 'ml-2')}>{text.dropOffAtPostOffice}</span>
            </label>
        </div>
    </div>
);
export default DeliveryMethodSelector;